import styled from "@emotion/styled";
import React, { FC } from "react";
import {
  AriaSwitchProps,
  useFocusRing,
  useSwitch,
  VisuallyHidden
} from "react-aria";
import { useToggleState } from "react-stately";
import { ToggleVisual } from "./ToggleVisual";

const Label = styled.label`
  display: flex;
  align-items: center;
  opacity: 1;
  cursor: pointer;
  position: relative;
  gap: 0.5rem;

  &[data-disabled="true"] {
    opacity: 0.4;
    pointer-events: none;
    cursor: not-allowed;
  }
`;

export const Toggle: FC<AriaSwitchProps> = (props) => {
  const state = useToggleState(props);
  const ref = React.useRef(null);
  const { inputProps } = useSwitch(props, state, ref);
  const { focusProps } = useFocusRing();

  return (
    <Label data-disabled={props.isDisabled}>
      <VisuallyHidden>
        <input {...inputProps} {...focusProps} ref={ref} />
      </VisuallyHidden>
      <ToggleVisual isSelected={state.isSelected} />
      {props.children}
    </Label>
  );
};
